import { ErrorBoundary } from 'react-error-boundary';
import type { ReactNode } from 'react';

import { ErrorDisplay } from './ErrorDisplay';

interface AppErrorBoundaryProps {
  children: ReactNode;
  /**
   * Changing these resets the boundary. Pass the pathname on a per-route boundary, or a
   * crash sticks after the user navigates away and the app looks permanently broken.
   */
  resetKeys?: unknown[];
}

export function AppErrorBoundary({ children, resetKeys }: AppErrorBoundaryProps) {
  return (
    <ErrorBoundary
      resetKeys={resetKeys}
      fallbackRender={({ error, resetErrorBoundary }) => (
        <ErrorDisplay
          error={error instanceof Error ? error : new Error(String(error))}
          resetErrorBoundary={resetErrorBoundary}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
